var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "formatter-form",
          attrs: {
            model: _vm.formatterItem.formatterCfg,
            "label-width": "80px",
            size: "mini",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("chart.value_formatter_type") } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.getExampleValue },
                  model: {
                    value: _vm.formatterItem.formatterCfg.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.formatterItem.formatterCfg, "type", $$v)
                    },
                    expression: "formatterItem.formatterCfg.type",
                  },
                },
                _vm._l(_vm.typeList, function (radio) {
                  return _c(
                    "el-radio",
                    { key: radio.value, attrs: { label: radio.value } },
                    [_vm._v(_vm._s(_vm.$t("chart." + radio.name)))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.formatterItem.formatterCfg.type !== "auto",
                  expression: "formatterItem.formatterCfg.type !== 'auto'",
                },
              ],
              attrs: { label: _vm.$t("chart.value_formatter_decimal_count") },
            },
            [
              _c("el-input-number", {
                attrs: { min: 0, max: 10, size: "mini" },
                on: { change: _vm.getExampleValue },
                model: {
                  value: _vm.formatterItem.formatterCfg.decimalCount,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formatterItem.formatterCfg,
                      "decimalCount",
                      $$v
                    )
                  },
                  expression: "formatterItem.formatterCfg.decimalCount",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.formatterItem.formatterCfg.type !== "percent",
                  expression: "formatterItem.formatterCfg.type !== 'percent'",
                },
              ],
              attrs: { label: _vm.$t("chart.value_formatter_unit") },
            },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: _vm.$t("chart.pls_select_field"),
                    size: "mini",
                  },
                  on: { change: _vm.getExampleValue },
                  model: {
                    value: _vm.formatterItem.formatterCfg.unit,
                    callback: function ($$v) {
                      _vm.$set(_vm.formatterItem.formatterCfg, "unit", $$v)
                    },
                    expression: "formatterItem.formatterCfg.unit",
                  },
                },
                _vm._l(_vm.unitList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: {
                      label: _vm.$t("chart." + item.name),
                      value: item.value,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("chart.value_formatter_suffix") } },
            [
              _c("el-input", {
                attrs: {
                  size: "mini",
                  clearable: "",
                  placeholder: _vm.$t("commons.input_content"),
                },
                on: { change: _vm.getExampleValue },
                model: {
                  value: _vm.formatterItem.formatterCfg.suffix,
                  callback: function ($$v) {
                    _vm.$set(_vm.formatterItem.formatterCfg, "suffix", $$v)
                  },
                  expression: "formatterItem.formatterCfg.suffix",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("chart.value_formatter_thousand_separator"),
              },
            },
            [
              _c("el-checkbox", {
                on: { change: _vm.getExampleValue },
                model: {
                  value: _vm.formatterItem.formatterCfg.thousandSeparator,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.formatterItem.formatterCfg,
                      "thousandSeparator",
                      $$v
                    )
                  },
                  expression: "formatterItem.formatterCfg.thousandSeparator",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("chart.value_formatter_example") } },
            [_c("span", [_vm._v(_vm._s(_vm.exampleResult))])]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }